import { render, staticRenderFns } from "./CtcSettings.vue?vue&type=template&id=495f48b0&scoped=true"
import script from "./CtcSettings.vue?vue&type=script&lang=js"
export * from "./CtcSettings.vue?vue&type=script&lang=js"
import style0 from "./CtcSettings.vue?vue&type=style&index=0&id=495f48b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495f48b0",
  null
  
)

export default component.exports